import * as $ from 'jquery';
import 'bootstrap';

export class searchpagebar {
	private $search = $('#searchpagebar-form');

	initSearchPageBar(): any {
		let _self = this;
		let searchform = this.$search;
		let inputfield = this.$search.find('.searchpagebar__searchbar');
		let clearbtn   = this.$search.find('.searchpagebar__clearbtn');
		let submitbtn  = this.$search.find('.searchpagebar__searchbtn');

		if (!searchform.length) {return false;}

		/**
		 * input field handler
		 * - display clear button if search input is filled
		 * @param {[event]} 'keyup'    [keyup event]
		 * @param {any}    e [event object]
		 */
		inputfield.on('keyup', function(e:any) {

			if (this.value.length) {
				clearbtn.fadeIn(150);
			}
		});

		/**
		 * clear button handler
		 * - empties search input when clicked
		 * - hides itself after
		 * @param {[event]} 'click'    [click event]
		 * @param {any}    e [event object]
		 */
		clearbtn.on('click', function(e:any) {

			inputfield[0].value = '';
			$(this).fadeOut(150);
		});

		/**
		 * submit form handler
		 * @param {[event]} 'click'    [click event]
		 * @param {any}    e [event object]
		 */
		submitbtn.on('click', function(e:any) {
		});
	}

	submitSearchBtn(): any{
		let $searchpageBtn: any = $('.searchpagebar__searchbtn');
		let $searchBar: any = $('.searchpagebar__searchbar');
		$searchpageBtn.attr('disabled',true);
	    $searchBar.keyup(function(){
	        if($(this).val().length !=0)
	            $searchpageBtn.attr('disabled', false);
	        else
	            $searchpageBtn.attr('disabled',true);
	    });
	}

	recentSearchHistory(): any{
	    let _self = this;
	    let $searchHistory: any = $('.searchpagebar__history .history__item a');
	    let $searchBar: any = $('.searchpagebar__searchbar');
	    let $searchpageBtn: any = $('.searchpagebar__searchbtn');

	    $searchHistory.on('click', function(){
	    	let $getSearchVal: any = $(this).html();
	    	$searchBar.val($getSearchVal);
	    	$searchpageBtn.attr('disabled', false);
	    });
	}
}

let scope:Element = document.querySelector('#searchpagebar-form');
if (scope){
	try {
		let searchPageBar = new searchpagebar();
		searchPageBar.initSearchPageBar();
		searchPageBar.submitSearchBtn();
		searchPageBar.recentSearchHistory();
	} catch(e) {console.error(e);}
}
